"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPendingMessage = exports.watchOnLoadedInitRecaptcha = exports.globalSagas = void 0;
var effects_1 = require("redux-saga/effects");
var WindowApi_1 = require("@/api/browser/WindowApi");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var MessageAction_1 = require("@/pages/common/actions/MessageAction");
var RootSaga_1 = require("@/pages/common/sagas/RootSaga");
var getAllState_1 = require("@/utils/getAllState");
var format_1 = require("@/utils/format");
var Api_1 = require("@/api/remote/Api");
var GlobalCallSaga_1 = require("@/pages/common/sagas/GlobalCallSaga");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var Analytics_1 = require("@/api/vendor/Analytics");
var stateFilter_2 = require("@/pages/common/sagas/stateFilter");
var MyDocumentApiSaga_1 = require("@/pages/document/sagas/api/MyDocumentApiSaga");
var EformDtoToEformState_1 = require("@/pages/document/transformers/EformDtoToEformState");
var UserAction_1 = require("@/pages/common/actions/UserAction");
var Pages_1 = require("@/rendering/common/Pages");
var getPendingMessage = function (state) { return state.translate.pendingMessage; };
exports.getPendingMessage = getPendingMessage;
var getPendingTitle = function (state) { return state.translate.pendingTitle; };
var getPendingActionText = function (state) { return state.translate.notifyView; };
var watchWindowResizeUpdateMobile = function () {
    var isMobile;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take([GlobalAction_1.default.ON_WINDOW_RESIZE, GlobalAction_1.default.ON_DOM_LOADED])];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.getIsMobile)];
            case 2:
                isMobile = _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setIsMobile(isMobile))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
/* Set body element scroll state */
var watchSetNoScrollSaga = function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.SET_NOSCROLL)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.call(WindowApi_1.setNoScrollBody, payload)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
/**
 * Toast a localizatble message at the top of the page
 */
var watchGlobalMessage = function () {
    var action, message, values, t, warningText;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take([GlobalAction_1.default.SET_GLOBAL_MESSAGE, GlobalAction_1.default.SET_GLOBAL_MESSAGE_LOCALIZED])];
            case 1:
                action = _a.sent();
                message = action.payload.message;
                values = action.payload.values;
                return [4 /*yield*/, effects_1.select(RootSaga_1.getGlobalTranslation)];
            case 2:
                t = _a.sent();
                if (action.type === GlobalAction_1.default.SET_GLOBAL_MESSAGE_LOCALIZED) {
                    message = t[message] ? t[message] : message;
                }
                message = format_1.default.print(message, values);
                return [4 /*yield*/, effects_1.put(MessageAction_1.default.onSetActive(true))];
            case 3:
                _a.sent();
                warningText = t.warning;
                return [4 /*yield*/, effects_1.put(MessageAction_1.default.onSetMessage(message, 0, warningText))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(function () {
                        var _a, closeClick, timeout;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, effects_1.race({
                                        closeClick: effects_1.take(MessageAction_1.default.ON_MESSAGE_CLOSE),
                                        timeout: effects_1.delay(5000),
                                    })];
                                case 1:
                                    _a = _b.sent(), closeClick = _a.closeClick, timeout = _a.timeout;
                                    if (!timeout) return [3 /*break*/, 4];
                                    return [4 /*yield*/, effects_1.put(MessageAction_1.default.onSetMessage(''))];
                                case 2:
                                    _b.sent();
                                    return [4 /*yield*/, effects_1.put(MessageAction_1.default.onSetActive(false))];
                                case 3:
                                    _b.sent();
                                    _b.label = 4;
                                case 4: return [2 /*return*/];
                            }
                        });
                    })];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
/* Emit Blur event on window's blur  */
var watchBlurSaga = function () {
    var channel;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (typeof (window) === 'undefined')
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.call(WindowApi_1.tabBlurListener)];
            case 1:
                channel = _a.sent();
                _a.label = 2;
            case 2:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(channel)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.onTabBlur())];
            case 4:
                _a.sent();
                return [3 /*break*/, 2];
            case 5: return [2 /*return*/];
        }
    });
};
/* Emit Focus event on window's focus  */
var watchFocusSaga = function () {
    var channel;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (typeof (window) === 'undefined')
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.call(WindowApi_1.tabFocusListener)];
            case 1:
                channel = _a.sent();
                _a.label = 2;
            case 2:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(channel)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.onTabFocus())];
            case 4:
                _a.sent();
                return [3 /*break*/, 2];
            case 5: return [2 /*return*/];
        }
    });
};
/* Set URL if changed. (Just console.log when in DEV mode)   */
var watchGlobalSetUrl = function () {
    var payload, url, forced, currentUrl, isProduction;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.GLOBAL_SET_URL)];
            case 1:
                payload = (_a.sent()).payload;
                url = payload.url;
                forced = payload.forced;
                return [4 /*yield*/, effects_1.call(WindowApi_1.getCurrentUrl)];
            case 2:
                currentUrl = _a.sent();
                if (!(url !== currentUrl || forced)) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.select(Api_1.isLocal)];
            case 3:
                isProduction = !(_a.sent());
                if (!isProduction) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.call(WindowApi_1.setUrl, url)];
            case 4:
                _a.sent();
                return [3 /*break*/, 6];
            case 5:
                console.log("SELURL: " + url);
                _a.label = 6;
            case 6: return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
};
/* Reload the page   */
var watchGlobalReload = function () {
    var isProduction;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.GLOBAL_RELOAD)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(Api_1.isLocal)];
            case 2:
                isProduction = !(_a.sent());
                if (!isProduction) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.call(WindowApi_1.reload)];
            case 3:
                _a.sent();
                return [3 /*break*/, 5];
            case 4:
                console.log('RELOAD');
                _a.label = 5;
            case 5: return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchOnLoadedInitRecaptcha = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.initGoogleRecaptcha)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
exports.watchOnLoadedInitRecaptcha = watchOnLoadedInitRecaptcha;
var watchPopState = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.POP_STATE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.popState)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchRestoreSavedState = function () {
    var savedState, actionName;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.getSavedState)];
            case 2:
                savedState = _a.sent();
                if (!savedState)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.call(getAllState_1.getAllState, savedState.page)];
            case 3:
                actionName = _a.sent();
                return [4 /*yield*/, effects_1.put({ type: actionName, payload: savedState })];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchLazyLoadImg = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(GlobalCallSaga_1.initLazyLoad)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchDomLoadedSetTrackingUserId = function () {
    var isMobile, userId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.getIsMobile)];
            case 2:
                isMobile = _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setIsMobile(isMobile))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getUserId)];
            case 4:
                userId = _a.sent();
                return [4 /*yield*/, effects_1.call(Analytics_1.setTrackingUserId, userId)];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchInitPendingDocumentAlert = function () {
    var lang, isGuest, currentPage, result, email, eforms, langCode, pendingCount, pendingMessage, pendingTitle, pendingActionText, pendingActionUrl;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 16];
                return [4 /*yield*/, effects_1.take([GlobalAction_1.default.ON_DOM_LOADED, UserAction_1.default.SET_USER_DONE])];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_2.getCurrentLanguageCode)];
            case 2:
                lang = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_2.isUserGuest)];
            case 3:
                isGuest = _a.sent();
                return [4 /*yield*/, effects_1.select(RootSaga_1.getCurrentPage)];
            case 4:
                currentPage = _a.sent();
                if (isGuest)
                    return [3 /*break*/, 0];
                if (currentPage === Pages_1.Pages.CONFIRM_EMAIL_REGISTER || currentPage === Pages_1.Pages.REVERIFY_EMAIL || currentPage === Pages_1.Pages.REVERIFY_EMAIL_RESULT)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.call(MyDocumentApiSaga_1.getPendingDocumentApi, 1)];
            case 5:
                result = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_2.getUserEmail)];
            case 6:
                email = _a.sent();
                if (!result || !result.results)
                    return [3 /*break*/, 0];
                eforms = result.results.map(EformDtoToEformState_1.EformDtoToEformState(lang, email));
                return [4 /*yield*/, effects_1.select(stateFilter_2.getCurrentLanguageCode)];
            case 7:
                langCode = _a.sent();
                pendingCount = eforms.length;
                return [4 /*yield*/, effects_1.select(getPendingMessage)];
            case 8:
                pendingMessage = _a.sent();
                return [4 /*yield*/, effects_1.select(getPendingTitle)];
            case 9:
                pendingTitle = _a.sent();
                return [4 /*yield*/, effects_1.select(getPendingActionText)];
            case 10:
                pendingActionText = _a.sent();
                pendingActionUrl = "/" + langCode + "/mydocument/pendingdocument";
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setUserIsAlert(pendingCount > 0))];
            case 11:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setPendingCount(pendingCount))];
            case 12:
                _a.sent();
                if (!(pendingCount > 0 && currentPage !== Pages_1.Pages.PENDING_DOCUMENT)) return [3 /*break*/, 15];
                return [4 /*yield*/, effects_1.put(MessageAction_1.default.onSetMessage(format_1.default.print(pendingMessage, ["" + pendingCount]), 1, pendingTitle, pendingActionUrl, pendingActionText))];
            case 13:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MessageAction_1.default.onSetActive(true))];
            case 14:
                _a.sent();
                _a.label = 15;
            case 15: return [3 /*break*/, 0];
            case 16: return [2 /*return*/];
        }
    });
};
var globalSagas = {
    watchSetNoScrollSaga: watchSetNoScrollSaga,
    watchGlobalMessage: watchGlobalMessage,
    watchBlurSaga: watchBlurSaga,
    watchFocusSaga: watchFocusSaga,
    watchGlobalSetUrl: watchGlobalSetUrl,
    watchGlobalReload: watchGlobalReload,
    watchPopState: watchPopState,
    watchRestoreSavedState: watchRestoreSavedState,
    watchWindowResizeUpdateMobile: watchWindowResizeUpdateMobile,
    watchLazyLoadImg: watchLazyLoadImg,
    watchDomLoadedSetTrackingUserId: watchDomLoadedSetTrackingUserId,
    watchInitPendingDocumentAlert: watchInitPendingDocumentAlert,
};
exports.globalSagas = globalSagas;
